import SiteMessagesInstance from '../components/site-messages';

// The name an enterprise's customers see beside the alerts it sets up for
// them ("Predefined by ..." in their Temp Stick app) is asked for until it is
// set: on any page, of a login that can set it (Settings > Profile). It never
// blocks; closed, it waits until the next visit. Not in the demo.

const LATER = 'tsProfileNameLater';

export default function askForProfileName(user) {

  if (/(^|;\s*)ts_enterprise_demo=1/.test(document.cookie)) return;
  if (!user || !(user.role >= (window.USER_ROLES ? window.USER_ROLES.SUPER_MANAGER : 99))) return;

  try {
    if (window.sessionStorage.getItem(LATER)) return;
  } catch (e) {
    // no storage: it asks on each page
  }

  // the Profile section is where it is set: no need to ask there
  if (/^\/settings/.test(window.location.pathname) && /profile/.test(window.location.search + window.location.hash)) return;

  Promise.resolve(window.apiRequest('get', '/profile', {}, { maxTries: 1 })).then(r => {

    if (!r || r.type !== 'success' || !r.data || !r.data.can_edit || r.data.customer_name) return;

    SiteMessagesInstance.addMessage('warning',
      `Add your business name. Linked accounts see it next to the Enterprise alerts you create for them. <a href="${window.site.home}/settings?section=profile">Add it in Settings</a>`,
      { id: 'profile-name', autoClose: 0, save: 0 });
    SiteMessagesInstance.displayMessages();

    const close = document.querySelector('.site-message[data-id="profile-name"] .site-message__close__button');
    if (close) {
      close.addEventListener('click', () => {
        try {
          window.sessionStorage.setItem(LATER, '1');
        } catch (e) {
          // no storage: it asks again on the next page
        }
      });
    }

  }).catch(() => {});

}
